import { IHttpApi } from '@cian/http-api';
import { assertResponseError } from './assert';
import {
  fetchCreateConsultingRequest,
  ICreateConsultingRequestRequest,
  ICreateConsultingRequestResponse400,
} from '../../repositories/newbuilding-flat-view-order/v1/create-consulting-request';

export const createConsultingRequest = async ({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: ICreateConsultingRequestRequest;
}): Promise<void> => {
  const result = await fetchCreateConsultingRequest<ICreateConsultingRequestResponse400>({ httpApi, parameters });

  assertResponseError(result);
};
